import React, { Fragment } from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader, Tab, Responsive
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';
import PollListTable from '../Util/PollListTable';
import PollInfo from '../AdminPoll/PollPreviewTabs/PollInfo/PollInfo';
import AdminPollPreview from '../AdminPoll/PollPreviewTabs/PollPreview/AdminPollPreview';
import ProfessorList from './ProfessorList';
import AssistantList from './AssistantList';
import { IconHeader } from '../../Professor/ProfessorInputGrades/css';
import ReactExport from 'react-data-export';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;

export default class StaffTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            staffList: { staffQuestionnaireDTOS: [] },
            activeIndex: 0,
            loadingGeneralReportData: false,
            loadingCommentsReportData: false,

            admin: !!localStorage.getItem('activeRole').includes('QA admin:'),
            orgUnitId: JSON.parse(localStorage.getItem('organizationalUnitId')),
            pollId: JSON.parse(localStorage.getItem('poll')).pollId,
        };
    }

    componentDidMount() {
        this.generateGeneralReport();
        this.generateCommentsReport();
    }

    generateCommentsReport = () => {
        this.setState({ loadingCommentsReportData: true });
        axios.get(this.state.admin ? `questionnaire/report-comments-for-admin/${this.state.pollId}/${this.state.orgUnitId}/`
            : `questionnaire/report-comments/${this.state.pollId}/`)
            .then(res => {
                // console.log(res.data);
                this.setState({
                    commentsExcelData: res.data
                        .map((el, index) => ([
                            { value: (index + 1) + '.' },
                            { value: el.employeeFirstName.trim() + ' ' + el.employeeLastName.trim() },
                            { value: el.courseName },
                            { value: el.textAnswer },
                            { value: el.numOfStudentsTotal },
                            { value: el.numOfStudentsGroup },
                        ])),
                    loadingCommentsReportData: false
                });
            })
            .catch(err => {
                toast('Greška prilikom učitavanja podataka za izvještaj.');
            });
    };

    groupByProfessorAndCourse = (data) => {
        const map = {};

        data.forEach(el => {
            const key = [
                el.employeeFirstName.trim(),
                el.employeeLastName.trim(),
                el.courseName,
                el.studyCycleName,
                el.courseRoleTypeName,
                el.questionText
            ].join('|');

            if (!map[key]) {
                map[key] = {
                    ...el,
                    semesters: [el.semesterNumber]
                };
            } else {
                map[key].semesters.push(el.semesterNumber);
            }
        });

        return Object.values(map)
            .map(el => ({
                ...el,
                semesterNumber: el.semesters.sort((a, b) => a - b).join(', ')
            }));
    };

    generateGeneralReport = () => {
        const formatAverage = (num) => {
            return num != null && num > 0 ? Number(num)
                .toFixed(2) : '-';
        };
        this.setState({ loadingGeneralReportData: true });

        axios.all([
            axios.get(this.state.admin ? `questionnaire/report-for-admin/${this.state.pollId}/${this.state.orgUnitId}/` : `questionnaire/report/${this.state.pollId}/`),
            axios.get(this.state.admin ? `questionnaire/report/questions-for-admin/${this.state.pollId}/${this.state.orgUnitId}/` : `questionnaire/report/questions/${this.state.pollId}/`)
        ])
            .then(axios.spread((reportRes, questionsRes) => {
                const groupedData = this.groupByProfessorAndCourse(reportRes.data);
                const mapToExcelRows = (data) =>
                    data.map((el, index) => ([
                        { value: `${index + 1}.` },
                        { value: `${el.employeeFirstName.trim()} ${el.employeeLastName.trim()}` },
                        { value: el.courseName },
                        { value: el.studyCycleName },
                        { value: el.semesterNumber },
                        { value: el.numOfStudentsAccessed },
                        { value: el.numOfStudentsBanned },
                        { value: el.numOfStudentsTotal },
                        { value: el.numOfStudentsGroup },
                        { value: formatAverage(el.courseAverageGrade) },
                        { value: formatAverage(el.totalAverageGrade) },
                    ]));

                this.setState({
                    professorExcelData: mapToExcelRows(
                        groupedData.filter(el => el.courseRoleTypeName === 'profesor')
                    ),
                    assistantExcelData: mapToExcelRows(
                        groupedData.filter(el => el.courseRoleTypeName === 'asistent')
                    ),
                    perQuestionsExcelData: this.groupByProfessorAndCourse(questionsRes.data)
                        .map((el, index) => ([
                            { value: `${index + 1}.` },
                            { value: `${el.employeeFirstName.trim()} ${el.employeeLastName.trim()}` },
                            { value: el.courseName },
                            { value: el.courseRoleTypeName },
                            { value: el.semesterNumber },
                            { value: el.studyCycleName },
                            { value: el.questionText },
                            { value: formatAverage(el.questionAverageGrade) },
                            { value: el.numOfStudentsAccessed },
                            { value: el.numOfStudentsBanned },
                            { value: el.numOfStudentsTotal },
                            { value: el.numOfStudentsGroup },
                            { value: formatAverage(el.courseAverageGrade) },
                            // { value: formatAverage(el.totalAverageGrade) },
                        ])),
                    loadingGeneralReportData: false
                });
            }))
            .catch(err => {
                toast('Greška prilikom učitavanja podataka za izvještaj.');
            });
    };

    handleTabChange = (e, { activeIndex }) => {
        this.setState({ activeIndex });
    };

    render() {
        // @formatter:off
        const questionnaireExcelColumns = [
            { title: 'R. br.', width: { wpx: 50 } },
            { title: 'Ime i prezime', width: { wpx: 300 } },
            { title: 'Naziv predmeta', width: { wpx: 300 } },
            { title: 'Ciklus studija', width: { wpx: 150 } },
            { title: 'Semestar', width: { wpx: 100 } },
            { title: 'Broj studenata koji su pristupili', width: { wpx: 200 } },
            { title: 'Broj studenata kojima je onemogućen pristup', width: { wpx: 325 } },
            { title: 'Ukupan broj studenata', width: { wpx: 150 } },
            { title: 'Broj studenata u grupi', width: { wpx: 150 } },
            { title: 'Prosječna ocjena na predmetu', width: { wpx: 200 } },
            { title: 'Ukupna prosječna ocjena', width: { wpx: 175 } },
        ];
        // @formatter:on

        const multiDataSetProfessor = [
            {
                columns: questionnaireExcelColumns,
                data: this.state.professorExcelData,
            }
        ];

        const multiDataSetAssistant = [
            {
                columns: questionnaireExcelColumns,
                data: this.state.assistantExcelData,
            }
        ];

        // @formatter:off
        const questionnairePerQuestionsExcelColumns = [
            { title: 'R. br.', width: { wpx: 50 } },
            { title: 'Ime i prezime', width: { wpx: 300 } },
            { title: 'Naziv predmeta', width: { wpx: 300 } },
            { title: 'Uloga na predmetu' , width: { wpx: 150 } },
            { title: 'Semestar', width: { wpx: 100 } },
            { title: 'Ciklus studija', width: { wpx: 150 } },
            { title: 'Pitanje', width: { wpx: 500 } },
            { title: 'Prosječna ocjena na pitanju', width: { wpx: 200 } },
            { title: 'Broj studenata koji su pristupili', width: { wpx: 200 } },
            { title: 'Broj studenata kojima je onemogućen pristup', width: { wpx: 325 } },
            { title: 'Ukupan broj studenata', width: { wpx: 150 } },
            { title: 'Broj studenata u grupi', width: { wpx: 150 } },
            { title: 'Prosječna ocjena na predmetu', width: { wpx: 200 } },
            // { title: 'Ukupna prosječna ocjena', width: { wpx: 175 } },
        ];
        // @formatter:on

        const multiDataSetPerQuestions = [
            {
                columns: questionnairePerQuestionsExcelColumns,
                data: this.state.perQuestionsExcelData,
            }
        ];

        // @formatter:off
        const multiDataSetComments = [
            {
                columns: [
                    { title: 'R. br.', width: { wpx: 50 } },
                    { title: 'Ime i prezime', width: { wpx: 300 } },
                    { title: 'Naziv predmeta', width: { wpx: 300 } },
                    { title: 'Komentar', width: { wpx: 1000 } },
                    { title: 'Ukupan broj studenata', width: { wpx: 150 } },
                    { title: 'Broj studenata u grupi', width: { wpx: 150 } },
                ],
                data: this.state.commentsExcelData,
            }
        ];
        // @formatter:on

        const panes = [
            {
                menuItem: 'Profesori',
                render: () => (<Tab.Pane as={Responsive} attached={false}>
                    <ProfessorList/>
                </Tab.Pane>)
            },
            {
                menuItem: 'Asistenti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <AssistantList/>
                    {/* {localStorage.getItem('student')?<StudentPollDetailes />:<AdminPollPreview />} */}
                </Tab.Pane>)
            },


        ];
        return (
            <div>
                <h1>{this.state.admin ? 'Rezultati' : 'Ankete'}</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            <Header.Content>
                               Osoblje {this.state.admin && ' - ' + localStorage.getItem('orgUnitName')}
                            </Header.Content>
                            <Header style={IconHeader} floated="right">
                                <Icon/>
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => window.history.go(-1)}
                                    />}
                                    content={<FormattedMessage id="common.back"/>}
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            <Header.Subheader floated="left">
                                {(localStorage.getItem('poll')) === 'null' ? ' ' : JSON.parse(localStorage.getItem('poll')).pollName}
                            </Header.Subheader>
                        </Header>
                    </Segment>
                    <Segment>
                        <ExcelFile filename={'Ukupni izvještaj'} element={
                            <Popup
                                trigger={<Button animated="vertical" color="blue" basic size="small"
                                                 style={{ textAlign: 'center' }}
                                                 disabled={this.state.loadingGeneralReportData}>
                                    <Button.Content hidden> <Icon name="download"/></Button.Content>
                                    <Button.Content visible>
                                        Ukupni izvještaj
                                    </Button.Content>
                                </Button>}
                                content="Preuzmi spisak u Excel-u"
                                hideOnScroll
                                position="top center"
                            />}>
                            <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSetProfessor)} name={'Profesori'}/>
                            <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSetAssistant)} name={'Asistenti'}/>
                            <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSetPerQuestions)} name={'Po pitanjima'}/>
                        </ExcelFile>
                        <ExcelFile filename={'Komentari'} element={
                            <Popup
                                trigger={<Button animated="vertical" color="blue" basic size="small"
                                                 style={{ textAlign: 'center' }}
                                                 disabled={this.state.loadingCommentsReportData}>
                                    <Button.Content hidden> <Icon name="download"/></Button.Content>
                                    <Button.Content visible>
                                        Komentari
                                    </Button.Content>
                                </Button>}
                                content="Preuzmi spisak u Excel-u"
                                hideOnScroll
                                position="top center"
                            />}>
                            <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSetComments)} name={'Komentari'}/>
                        </ExcelFile>
                    </Segment>
                    <Segment clearing>
                        <Tab menu={{
                            secondary: true,
                            pointing: true,
                            color: 'blue'
                        }} panes={panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange}/>
                    </Segment>
                </Segment.Group>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/QAPoll/StaffTabs.js